import React from 'react';
import { Modal } from 'antd';
import { ekaScribeExtensionDownloadURL } from '../../constants';
import { Timeline } from 'antd';
import { track } from '../../tracking';

export type ekaScribeSuccessfulModalInstallation = {
    isOpen: boolean;
    onClose: () => void;
    title?: string;
};
const timelineSteps = [
    {
        image: '/images/v2rxModalPart1.png',
        title: 'Install the EkaScribe plugin from the chrome store',
        buttonLabel: 'Install Eka Scribe',
        buttonOnClick: () => {
            track('GET_EKASCRIBE_VOICE_TO_RX_EXTENAION');
            window.open(ekaScribeExtensionDownloadURL, '_blank');
        },
        buttonIcon: (
            <svg
                className="ml-4"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.21875 2.73438C9.21875 2.4043 9.47266 2.125 9.82812 2.125L13.8652 2.125C14.2207 2.125 14.4746 2.4043 14.4746 2.73438V6.79688C14.4746 7.15234 14.2207 7.40625 13.8652 7.40625C13.5352 7.40625 13.2559 7.15234 13.2559 6.79688V4.20703L7.59375 9.86914C7.36523 10.123 6.98437 10.123 6.75586 9.86914C6.50195 9.64062 6.50195 9.25977 6.75586 9.00586L12.418 3.34375L9.82812 3.34375C9.47266 3.34375 9.21875 3.08984 9.21875 2.73438ZM3.32812 2.9375L6.57812 2.9375C6.9082 2.9375 7.1875 3.2168 7.1875 3.54688C7.1875 3.90234 6.9082 4.15625 6.57812 4.15625L3.32812 4.15625C2.97266 4.15625 2.71875 4.43555 2.71875 4.76562L2.71875 13.2969C2.71875 13.6523 2.97266 13.9062 3.32812 13.9062L11.8594 13.9063C12.1895 13.9063 12.4687 13.6523 12.4687 13.2969V10.0469C12.4687 9.7168 12.7227 9.4375 13.0781 9.4375C13.4082 9.4375 13.6875 9.7168 13.6875 10.0469V13.2969C13.6875 14.3125 12.8496 15.125 11.8594 15.125L3.32812 15.125C2.3125 15.125 1.5 14.3125 1.5 13.2969L1.5 4.76562C1.5 3.77539 2.3125 2.9375 3.32812 2.9375Z"
                    fill="white"
                />
            </svg>
        ),
    },
    {
        image: '/images/v2rxModalPart2.png',
        title: 'Refresh the page once',
        buttonLabel: 'Refresh Page',
        buttonOnClick: () => {
            track('GET_EKASCRIBE_VOICE_TO_RX_REFRESH');
            sessionStorage.setItem('openV2rxModalAgain_ReloadTriggedFromModal', 'true');
            window.location.reload();
        },
        buttonIcon: (
            <svg
                className="ml-4"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M2.05859 9.23438C1.72852 9.23438 1.47461 8.92969 1.5 8.59961V8.39648C1.62695 5.9082 3.68359 3.95313 6.17188 3.95313L9.21875 3.95313V3.03906C9.21875 2.53125 9.59961 2.125 10.1074 2.125C10.3359 2.125 10.5391 2.22656 10.7168 2.37891L12.6719 4.13086C12.7988 4.23242 12.875 4.41016 12.875 4.5625C12.875 4.74023 12.7988 4.91797 12.6719 5.01953L10.7168 6.77148C10.5391 6.92383 10.3359 7 10.1074 7C9.625 7 9.21875 6.59375 9.21875 6.11133V5.17188L6.17187 5.17188C4.31836 5.17188 2.82031 6.61914 2.71875 8.47266V8.67578C2.69336 9.00586 2.41406 9.25977 2.05859 9.23438ZM10.4375 5.40039L11.3516 4.5625L10.4375 3.75V5.40039ZM13.916 8.01563C14.2461 8.04102 14.5 8.32031 14.5 8.67578L14.4746 8.87891C14.3477 11.3672 12.291 13.2969 9.80273 13.2969L6.78125 13.2969V14.2363C6.78125 14.7188 6.375 15.125 5.86719 15.125C5.63867 15.125 5.43555 15.0488 5.25781 14.8965L3.30273 13.1445C3.17578 13.043 3.125 12.8652 3.125 12.7129C3.125 12.5352 3.17578 12.3574 3.30273 12.2559L5.25781 10.5039C5.43555 10.3516 5.63867 10.2754 5.86719 10.2754C6.375 10.2754 6.78125 10.6816 6.78125 11.1641V12.0781L9.80273 12.0781C11.6562 12.0781 13.1797 10.6563 13.2559 8.80273L13.2812 8.59961C13.2812 8.26953 13.5605 8.01563 13.916 8.01563ZM5.5625 11.875L4.62305 12.6875L5.5625 13.5254V11.875Z"
                    fill="white"
                />
            </svg>
        ),
    },
    {
        image: '/images/v2rxModalPart3.png',
        title: 'Click the "EkaScribe" button on your prescription pad to use Voice-to-Rx',
        subtitle:
            'You can also find it in the puzzle icon 🧩 in the right of your address bar in chrome',
    },
];

const Voice2RXModalQueuePage: React.FC<ekaScribeSuccessfulModalInstallation> = ({
    isOpen,
    onClose,
}) => {
    return (
        <Modal
            visible={isOpen}
            centered
            closable
            maskClosable
            onCancel={onClose}
            keyboard
            destroyOnClose
            footer={null}
            className="ekaScribeInstallationSuccessModalBody"
            width={'35.2rem'}
        >
            <p className="font-lato text-20 font-700 mb-20">Start Using Voice-to-Rx in 3 steps!</p>
            <div className="flex items-start gap-16 ml-12">
                <Timeline className="timelineComponentWrapperv2RxModal">
                    {timelineSteps.map((step, idx) => (
                        <Timeline.Item
                            key={idx}
                            style={{
                                paddingBottom: idx == 2 ? '0' : '28',
                            }}
                            dot={
                                <div className="border-darwin-neutral_new-200 w-32 h-32 rounded-full bg-white border-4 mt-4 text-darwin-neutral_new-600 text-13 flex items-center justify-center font-700">
                                    {idx + 1}
                                </div>
                            }
                        >
                            <div className="flex gap-16 items-center ml-12">
                                <img
                                    src={step.image}
                                    className="rounded-8 border border-darwin-neutral_new-200 w-168"
                                />
                                <div className="flex flex-col gap-8 w-266">
                                    <p className="font-lato text-14 font-700">{step.title}</p>
                                    {step.subtitle && (
                                        <p className="text-13 text-darwin-neutral_new-600">
                                            {step.subtitle}
                                        </p>
                                    )}
                                    {step.buttonLabel && (
                                        <button
                                            onClick={step.buttonOnClick}
                                            className="rounded-4 w-fitContent bg-darwin-accent-bright-blue-800 px-8 h-28 text-white font-700 text-12 flex justify-center items-center"
                                        >
                                            {step.buttonLabel}
                                            {step.buttonIcon}
                                        </button>
                                    )}
                                </div>
                            </div>
                        </Timeline.Item>
                    ))}
                </Timeline>
            </div>
        </Modal>
    );
};

export default Voice2RXModalQueuePage;
